import { ReactNode, useEffect } from "react";
import Aos from "aos";
import "aos/dist/aos.css";

export interface CardProps {
    animation?: string;
    className?: string;
    children: ReactNode;
}

export function Card(props: CardProps) {

    useEffect(function () {
        Aos.init({ duration: 1000 });
    }, []);

    return (
        <div className={`flow-card ${props.className ?? ''}`}
            data-aos={props.animation}
            
        >
            {props.children}

        </div>
    );


}


